import de from "./de.json";
import en from "./en.json";

export const onboardingTranslations = { de, en };
